import React from 'react';
import { Box, Stack } from '@mui/material';
import HtmlEditor from '../../../Components/Utilities/HtmlEditor';
import { MultilineFormTextField } from '../../../Components/CustomUIElements/FormTextField';
import { classes } from '../styles';

interface QuestionEditorProps {
  title: string;
  label: string;
  setLabel: (label: string) => void;
  errorLabel: string;
  setErrorLabel?: (errorLabel: string) => void;
  labelRef?: React.RefObject<HTMLDivElement>;
  noLeftMargin?: boolean;
}

const QuestionEditor = ({
  title,
  label,
  setLabel,
  errorLabel,
  setErrorLabel,
  labelRef,
  noLeftMargin
}: QuestionEditorProps) => {
  const isCypress = typeof window !== 'undefined' && (window as any).Cypress;

  // NOTE: TinyMCE is too difficult to test with Cypress, so we revert to the original simple textarea if Cypress is detected
  if (isCypress) {
    return (
      <Box sx={{ marginLeft: noLeftMargin ? '0px' : '15px' }}>
        <Box sx={classes.modalFormLine}>
          <MultilineFormTextField
            value={label}
            onChange={(e) => {
              setErrorLabel && setErrorLabel('');
              setLabel(e.target.value);
            }}
            styles={{ width: '600px', marginTop: '20px' }}
            rows={6}
            innerRef={labelRef as any}
            error={errorLabel}
            label={title}
            dataTestId="field-label"
          />
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ marginLeft: noLeftMargin ? '0px' : '15px' }}>
      <Box sx={classes.modalFormLine}>
        <Stack sx={{ rowGap: 1, width: '100%' }}>
          <Stack sx={{ color: '#838383' }}>{title}</Stack>
          <HtmlEditor
            body={label}
            onBlur={(value) => {
              setErrorLabel && setErrorLabel('');
              setLabel(value);
            }}
            maxHeight={300}
          />
          {errorLabel && (
            <Box sx={{ ...classes.inlineError, marginLeft: 1 }} ref={labelRef || undefined}>
              {errorLabel}
            </Box>
          )}
        </Stack>
      </Box>
    </Box>
  );
};

export default QuestionEditor;
